var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 59,
    viewBox: "0 0 204 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.396 59H7.55371C3.40106 59 0 55.6794 0 51.625V7.375C0 3.3206 3.40106 1.7097e-06 7.55371 1.7097e-06H196.396C200.549 1.7097e-06 203.95 3.3206 203.95 7.375V51.625C203.95 55.6794 200.549 59 196.396 59Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.396 1.18184C199.894 1.18184 202.74 3.96038 202.74 7.375V51.625C202.74 55.0396 199.894 57.8182 196.396 57.8182H7.55371C4.05634 57.8182 1.21048 55.0396 1.21048 51.625V7.375C1.21048 3.96038 4.05634 1.18184 7.55371 1.18184H196.396ZM196.396 1.7097e-06H7.55371C3.40106 1.7097e-06 0 3.3206 0 7.375V51.625C0 55.6794 3.40106 59 7.55371 59H196.396C200.549 59 203.95 55.6794 203.95 51.625V7.375C203.95 3.3206 200.549 1.7097e-06 196.396 1.7097e-06Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6353 15.1096C71.6353 16.3413 71.2576 17.3277 70.5136 18.0633C69.6581 18.9354 68.5439 19.3742 67.1786 19.3742C65.8737 19.3742 64.7595 18.928 63.8455 18.0486C62.9297 17.1562 62.4727 16.061 62.4727 14.7501C62.4727 13.4392 62.9297 12.344 63.8455 11.459C64.7595 10.5722 65.8737 10.126 67.1786 10.126C67.8282 10.126 68.4476 10.2569 69.0387 10.5003C69.6279 10.7455 70.1076 11.0774 70.455 11.4867L69.6657 12.2647C69.0595 11.5659 68.2342 11.2212 67.1786 11.2212C66.2268 11.2212 65.4016 11.5457 64.701 12.2002C64.0079 12.8566 63.6605 13.7065 63.6605 14.7501C63.6605 15.7937 64.0079 16.651 64.701 17.3074C65.4016 17.9545 66.2268 18.2864 67.1786 18.2864C68.1889 18.2864 69.0387 17.9545 69.7091 17.3C70.151 16.8667 70.4022 16.2694 70.4683 15.506H67.1786V14.4404H71.5673C71.6202 14.6708 71.6353 14.8939 71.6353 15.1096Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5981 11.4146H74.4756V14.2171H78.1921V15.2828H74.4756V18.0853H78.5981V19.1712H73.3086V10.3286H78.5981V11.4146Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5121 19.1712H82.345V11.4146H79.8164V10.3286H86.0425V11.4146H83.5121V19.1712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5469 19.1712V10.3286H91.712V19.1712H90.5469Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8792 19.1712H95.7216V11.4146H93.1836V10.3286H99.4173V11.4146H96.8792V19.1712Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.205 18.0338C110.312 18.928 109.205 19.3742 107.885 19.3742C106.558 19.3742 105.451 18.928 104.558 18.0338C103.666 17.1414 103.223 16.0463 103.223 14.7501C103.223 13.4539 103.666 12.3588 104.558 11.4664C105.451 10.5722 106.558 10.126 107.885 10.126C109.198 10.126 110.304 10.5722 111.197 11.4738C112.096 12.3735 112.54 13.4613 112.54 14.7501C112.54 16.0463 112.096 17.1414 111.205 18.0338ZM105.421 17.2926C106.093 17.9545 106.911 18.2864 107.885 18.2864C108.852 18.2864 109.677 17.9545 110.342 17.2926C111.012 16.6307 111.352 15.7808 111.352 14.7501C111.352 13.7194 111.012 12.8695 110.342 12.2076C109.677 11.5457 108.852 11.2138 107.885 11.2138C106.911 11.2138 106.093 11.5457 105.421 12.2076C104.75 12.8695 104.41 13.7194 104.41 14.7501C104.41 15.7808 104.75 16.6307 105.421 17.2926Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.176 19.1712V10.3286H115.592L119.996 17.2058H120.047L119.996 15.5059V10.3286H121.161V19.1712H119.945L115.333 11.9548H115.282L115.333 13.6621V19.1712H114.176Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M102.934 32.0848C99.3852 32.0848 96.4864 34.7214 96.4864 38.3591C96.4864 41.9673 99.3852 44.6315 102.934 44.6315C106.489 44.6315 109.388 41.9673 109.388 38.3591C109.388 34.7214 106.489 32.0848 102.934 32.0848ZM102.934 42.1609C100.987 42.1609 99.3115 40.5919 99.3115 38.3591C99.3115 36.0968 100.987 34.5554 102.934 34.5554C104.88 34.5554 106.563 36.0968 106.563 38.3591C106.563 40.5919 104.88 42.1609 102.934 42.1609ZM88.8666 32.0848C85.3107 32.0848 82.4195 34.7214 82.4195 38.3591C82.4195 41.9673 85.3107 44.6315 88.8666 44.6315C92.4206 44.6315 95.3137 41.9673 95.3137 38.3591C95.3137 34.7214 92.4206 32.0848 88.8666 32.0848ZM88.8666 42.1609C86.9178 42.1609 85.2371 40.5919 85.2371 38.3591C85.2371 36.0968 86.9178 34.5554 88.8666 34.5554C90.8136 34.5554 92.4886 36.0968 92.4886 38.3591C92.4886 40.5919 90.8136 42.1609 88.8666 42.1609ZM72.1276 34.0078V36.6739H78.6484C78.4576 38.1636 77.9478 39.2588 77.1659 40.0221C76.2142 40.944 74.7318 41.9673 72.1276 41.9673C68.1147 41.9673 64.9724 38.8053 64.9724 34.8873C64.9724 30.9693 68.1147 27.8073 72.1276 27.8073C74.2974 27.8073 75.8762 28.6351 77.0413 29.7082L78.9656 27.8294C77.3359 26.3102 75.168 25.1431 72.1276 25.1431C66.6248 25.1431 62 29.5146 62 34.8873C62 40.26 66.6248 44.6315 72.1276 44.6315C75.1019 44.6315 77.3359 43.6801 79.0921 41.8954C80.8918 40.1383 81.4527 37.6677 81.4527 35.6727C81.4527 35.0532 81.3998 34.4835 81.3054 34.0078H72.1276ZM140.576 36.0747C140.045 34.6716 138.408 32.0848 135.073 32.0848C131.768 32.0848 129.016 34.6273 129.016 38.3591C129.016 41.8733 131.74 44.6315 135.39 44.6315C138.341 44.6315 140.045 42.8744 140.745 41.8511L138.555 40.4259C137.824 41.4695 136.829 42.1609 135.39 42.1609C133.96 42.1609 132.935 41.5211 132.278 40.26L140.872 36.7882L140.576 36.0747ZM131.813 38.1636C131.74 35.7446 133.738 34.5056 135.169 34.5056C136.291 34.5056 137.242 35.0532 137.56 35.8368L131.813 38.1636ZM124.828 44.2499H127.653V25.8124H124.828V44.2499ZM120.201 33.4824H120.107C119.472 32.7485 118.262 32.0848 116.728 32.0848C113.511 32.0848 110.568 34.843 110.568 38.3794C110.568 41.8954 113.511 44.6315 116.728 44.6315C118.262 44.6315 119.472 43.9622 120.107 43.2063H120.201V44.106C120.201 46.5048 118.889 47.7935 116.772 47.7935C115.046 47.7935 113.975 46.5767 113.533 45.5534L111.076 46.5545C111.785 48.2176 113.66 50.2642 116.772 50.2642C120.084 50.2642 122.879 48.3614 122.879 43.7318V32.4664H120.201V33.4824ZM116.97 42.1609C115.023 42.1609 113.393 40.5697 113.393 38.3794C113.393 36.1687 115.023 34.5554 116.97 34.5554C118.889 34.5554 120.401 36.1687 120.401 38.3794C120.401 40.5697 118.889 42.1609 116.97 42.1609ZM153.802 25.8124H147.045V44.2499H149.863V37.2639H153.802C156.931 37.2639 160 35.0532 160 31.5372C160 28.023 156.924 25.8124 153.802 25.8124ZM153.876 34.6992H149.863V28.377H153.876C155.979 28.377 157.18 30.0825 157.18 31.5372C157.18 32.9643 155.979 34.6992 153.876 34.6992ZM171.293 32.0498C169.257 32.0498 167.14 32.9274 166.269 34.8725L168.77 35.8958C169.308 34.8725 170.297 34.5407 171.344 34.5407C172.805 34.5407 174.288 35.398 174.31 36.9117V37.1053C173.8 36.8177 172.709 36.3918 171.366 36.3918C168.673 36.3918 165.929 37.8391 165.929 40.5402C165.929 43.0109 168.135 44.602 170.615 44.602C172.511 44.602 173.557 43.7668 174.214 42.7951H174.31V44.2203H177.032V37.1477C177.032 33.8788 174.531 32.0498 171.293 32.0498ZM170.953 42.1535C170.031 42.1535 168.747 41.7073 168.747 40.5919C168.747 39.1648 170.348 38.6172 171.735 38.6172C172.975 38.6172 173.557 38.8845 174.31 39.2367C174.089 40.944 172.584 42.1535 170.953 42.1535ZM186.946 32.4535L183.707 40.4462H183.611L180.263 32.4535H177.224L182.255 43.623L179.385 49.8383H182.329L190.081 32.4535H186.946ZM161.548 44.2499H164.373V25.8124H161.548V44.2499Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7631 11.1197C15.3193 11.5732 15.0625 12.2794 15.0625 13.1939V45.8135C15.0625 46.728 15.3193 47.4342 15.7631 47.8877L15.8726 47.9873L34.5945 29.7157V29.2843L15.8726 11.0127L15.7631 11.1197Z",
    fill: "url(#paint0_linear_5825_10093)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8314 35.8091L34.5977 29.7155V29.2841L40.8389 23.1905L40.9786 23.2697L48.3699 27.3758C50.4793 28.541 50.4793 30.4585 48.3699 31.6311L40.9786 35.7298L40.8314 35.8091Z",
    fill: "url(#paint1_linear_5825_10093)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.978 35.7299L34.597 29.4999L15.7656 47.8876C16.4662 48.6067 17.6087 48.6933 18.908 47.9742L40.978 35.7299Z",
    fill: "url(#paint2_linear_5825_10093)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.978 23.27L18.908 11.0256C17.6087 10.3139 16.4662 10.4006 15.7656 11.1197L34.597 29.5L40.978 23.27Z",
    fill: "url(#paint3_linear_5825_10093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5825_10093",
    x1: 32.9322,
    y1: 46.1532,
    x2: 8.18527,
    y2: 20.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5825_10093",
    x1: 51.1167,
    y1: 29.4977,
    x2: 14.5615,
    y2: 29.4977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5825_10093",
    x1: 37.5082,
    y1: 26.1131,
    x2: 3.94934,
    y2: -8.25892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5825_10093",
    x1: 11.0254,
    y1: 58.7401,
    x2: 26.0109,
    y2: 43.3916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStore);
export default __webpack_public_path__ + "static/media/GoogleStore.7ac7bd7cde2563971a83dcc659ffe9c4.svg";
export { ForwardRef as ReactComponent };